import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

/**
 * فیلتر انتخاب نوع منبع
 */
export const ResourceTypeFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const handleChangeResourceType = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  const resourceTypes = [
    {
      id: 'news_agency',
      label: t('filter:newsAgency'),
      testId: 'filter-resource-type-news_agency-checkbox',
      labelTestId: 'filter-resource-type-news_agency-label',
    },
    {
      id: 'news_station',
      label: t('filter:newsStation'),
      testId: 'filter-resource-type-news_station-checkbox',
      labelTestId: 'filter-resource-type-news_station-label',
    },
    {
      id: 'search_engine',
      label: t('filter:searchEngine'),
      testId: 'filter-resource-type-search_engine-checkbox',
      labelTestId: 'filter-resource-type-search_engine-label',
    },
    {
      id: 'foreign_news_agency',
      label: t('filter:foreignNewsAgencies'),
      testId: 'filter-resource-type-foreign_news_agency-checkbox',
      labelTestId: 'filter-resource-type-foreign_news_agency-label',
    },
  ];

  return (
    <div className={classNames('grid', className)}>
      {resourceTypes.map(({ id, label, testId, labelTestId }) => (
        <UiFormControlLabel
          key={id}
          className='mr-0'
          label={label}
          data-testid={labelTestId}
          control={
            <UiCheckbox
              checked={selectedIds?.includes(id)}
              name={id}
              inputProps={{ 'data-testid': testId }}
              onChange={(event) => handleChangeResourceType(event, id)}
              disabled={filter?.isDisabled}
            />
          }
        />
      ))}
    </div>
  );
};

ResourceTypeFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
